import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.878 10.602a.606.606 0 0 1 0-.535l.771-1.577a1.794 1.794 0 0 0-.774-2.383l-1.551-.823a.606.606 0 0 1-.315-.433l-.3-1.729a1.8 1.8 0 0 0-2.027-1.473l-1.741.247a.606.606 0 0 1-.509-.165L11.17.51a1.794 1.794 0 0 0-2.506 0L7.403 1.731a.606.606 0 0 1-.509.165L5.156 1.65a1.794 1.794 0 0 0-2.027 1.473l-.3 1.729a.606.606 0 0 1-.315.433l-1.551.823a1.794 1.794 0 0 0-.774 2.383l.771 1.577a.606.606 0 0 1 0 .535L.189 12.18a1.794 1.794 0 0 0 .774 2.383l1.551.823a.606.606 0 0 1 .315.433l.3 1.729a1.793 1.793 0 0 0 1.769 1.491 1.843 1.843 0 0 0 .258-.018l1.738-.246a.606.606 0 0 1 .509.165l1.262 1.221a1.794 1.794 0 0 0 2.506 0l1.262-1.221a.606.606 0 0 1 .509-.165l1.738.246a1.794 1.794 0 0 0 2.027-1.473l.3-1.729a.606.606 0 0 1 .315-.433l1.551-.823a1.794 1.794 0 0 0 .774-2.383ZM7.533 4.971a2.186 2.186 0 1 1-2.186 2.186 2.188 2.188 0 0 1 2.186-2.186Zm-1.128 9.72a.6.6 0 0 1-.843-.843L13.43 5.98a.6.6 0 0 1 .843.843Zm5.9 1.009a2.186 2.186 0 1 1 2.186-2.186 2.188 2.188 0 0 1-2.189 2.188Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.302 12.521a.993.993 0 1 0 .993.993.995.995 0 0 0-.993-.993Zm-4.77-6.358a.993.993 0 1 0 .994.993.995.995 0 0 0-.994-.993Z"
    }, null, -1)
  ])))
}
export default { render: render }